// lib/list/listProjectOutputs.ts
import type { KernelHandle } from '#types/types';
import { getLayerWorkspaceId } from '#types/types';
import { buildProjectListProjection, normalizeWorkspaceVersionForList } from '#lib/project-list-projection';
import { listProjectWorkspaces } from '#lib/studio-list-focus';

export function readListProjectOutputs(kernel: KernelHandle, projectId: string) {
  const inventory = kernel.getInventory();
  const workspaces = listProjectWorkspaces(kernel, projectId);
  const versionsByWorkspace = new Map(workspaces.map(workspace => [workspace.id, new Map((workspace.versions ?? []).map(version => [version.id, version]))]));
  for (const dto of Object.values(inventory.StudioWorkspace?.registry ?? {})) {
    if (dto.projectId !== projectId || versionsByWorkspace.has(dto.id)) continue;
    const workspace = kernel.getWorkspace(dto.id);
    versionsByWorkspace.set(dto.id, new Map((workspace?.projectId === projectId ? workspace.versions ?? [] : []).map(version => [version.id, version])));
  }
  for (const version of Object.values(inventory.StudioWorkspaceVersion?.registry ?? {})) {
    if (version.projectId !== projectId) continue;
    const versions = versionsByWorkspace.get(version.workspaceId) ?? new Map();
    versions.set(version.id, normalizeWorkspaceVersionForList(version));
    versionsByWorkspace.set(version.workspaceId, versions);
  }
  const layers = Object.values(kernel.getLayerRegistry()).filter(layer => layer.projectId === projectId);
  const layersByWorkspace = new Map<string, typeof layers>();
  for (const layer of layers) {
    const workspaceId = getLayerWorkspaceId(layer);
    if (!workspaceId) continue;
    const workspaceLayers = layersByWorkspace.get(workspaceId) ?? [];
    workspaceLayers.push(layer);
    layersByWorkspace.set(workspaceId, workspaceLayers);
  }
  return { layersByWorkspace, projection: buildProjectListProjection(projectId, layers,
    [...versionsByWorkspace].map(([id, versions]) => ({ id, projectId, versions: [...versions.values()] }))) };
}
